module.exports = __webpack_public_path__ + "static/media/Ex1-S8.cfa15387.PNG";